import { Component, Inject, InjectionToken, Injector, Optional, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { FiUserSignInSettings } from '@fi-app/user/user-edit/fi-user-sign-in-settings';
import { FiContactsService } from '@fi-shared/fi-contacts/fi-contacts.service';
import { IFiContactData } from '@fi-shared/fi-contacts/fi-contacts';
import { IContactModel } from '@fi-shared/models/common';

export type TFiUserEditDataFieldPhoneNumber_Settings = {
    isCountryCodeNewLayout: boolean;
    isNewAddButtonLayout: boolean;
    fiUserSignInSettings?: FiUserSignInSettings;
    contactData?: IFiContactData;
};
export const FiUserEditDataFieldPhoneNumber_Settings = new InjectionToken<TFiUserEditDataFieldPhoneNumber_Settings>(
    'FiUserEditDataFieldPhoneNumber_Settings',
);

@Component({
    selector: 'data-field-edit-phone-number',
    template: `
        <fi-phone-number-contacts
            [(ngModel)]="dataFieldObject.PhoneNumberContacts"
            (onContactChange)="contactChanged($event)"
            [isRequired]="dataField.IsSetRequired"
            [isCountryCodeNewLayout]="isCountryCodeLayout()"
            [isNewAddButtonLayout]="isNewAddButtonLayout()"
            [contactData]="contactData"
            [userId]="dataFieldObject.Id"
            [isSystemObject]="dataFieldObject.IsSyststemObject"
            [fiUserSignInSettings]="getFiUserSignInSettings()"
        >
        </fi-phone-number-contacts>
    `,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'data-field-edit-phone-number' },
    standalone: false,
})
export class DataFieldEditPhoneNumberComponent extends DataFieldEditBase {
    contactData: IFiContactData;

    constructor(
        injector: Injector,
        @Optional()
        @Inject(FiUserEditDataFieldPhoneNumber_Settings)
        private settings: TFiUserEditDataFieldPhoneNumber_Settings,
        private fiContactsService: FiContactsService,
    ) {
        super(injector);
        this.contactData = this.getContactData();
    }

    private getContactData(): IFiContactData {
        return (
            this.settings?.contactData ??
            this.fiContactsService.getContactData(() => this.dataFieldObject.PhoneNumberContacts)
        );
    }

    getFiUserSignInSettings(): FiUserSignInSettings {
        return this.settings?.fiUserSignInSettings;
    }

    isCountryCodeLayout(): boolean {
        return this.settings?.isCountryCodeNewLayout;
    }

    isNewAddButtonLayout(): boolean {
        return this.settings?.isNewAddButtonLayout;
    }

    contactChanged($event: IContactModel) {
        this.contactData.onContactValueChanged($event);
    }
}
